/* eslint-disable @next/next/no-img-element */
"use client";
import React, { useCallback, useContext, useEffect } from "react";
import "./index.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Navigation, Pagination, EffectCoverflow } from "swiper/modules";
import { Rate, Typography, Tooltip } from "@arco-design/web-react";
import "swiper/css";
import "swiper/css/pagination";
SwiperCore.use([Navigation, Pagination]);
import { useProducts } from "@/api/about/use-query";
import { TProductsProp } from "@/typings/about";
import { EProductRecommendType } from "@/shared/enums/about";
import ClientLink from "@/components/ClientLink";
import { LoginContext } from "@/app/LoginProvider";
import { useTrackingRecordSave } from "@/api/track/use-query";
import {
  RouteStack,
  TrackingEventID,
  TrackingEventPageID,
  TrackingEventType,
} from "@/shared";

const HighCommissions = () => {
  const { mutate: fetchProducts, data: productList } = useProducts();
  const { mutate: fetchTrackingRecordSave } = useTrackingRecordSave();
  const loginCtx = useContext(LoginContext);

  useEffect(() => {
    fetchProducts({ recommendType: EProductRecommendType.HighCos });
  }, [fetchProducts]);

  const handleTrackingProduct = useCallback(
    (product_id: string) => {
      fetchTrackingRecordSave({
        uid: loginCtx?.userInfo?.uid,
        event_id: TrackingEventID.ProductCard,
        event_type: TrackingEventType.Click,
        page_id: TrackingEventPageID.AboutUs,
        product_id: product_id,
      });
    },
    [loginCtx?.userInfo?.uid, fetchTrackingRecordSave]
  );

  return (
    <div className="yf-product-high-wrapper">
      <Swiper
        spaceBetween={40} // 间距
        slidesPerView={2} // 每次显示的元素数量
        centeredSlides={true} // 居中显示
        loop={true} // 循环
        className="w-full mt-9"
        pagination={{ clickable: true }}
        modules={[EffectCoverflow, Pagination, Navigation]}
      >
        {(productList?.data?.products || []).map(
          (item: TProductsProp, index) => {
            return (
              <SwiperSlide key={item.first_category_name + index}>
                <ClientLink
                  href={`/${RouteStack.Product.product}/${item.hash_id}`}
                  onClick={handleTrackingProduct.bind(null, item?.product_id)}
                >
                  <div className="slide-content cursor-pointer">
                    <div>
                      <div className="category-name mb-2">
                        {item.first_category_name}
                      </div>
                      <Tooltip content={item.product_name}>
                        <div className="product-name cursor-pointer">
                          {item.product_name}
                        </div>
                      </Tooltip>
                      <div className="flex items-center">
                        <Rate
                          allowHalf
                          defaultValue={item.rating}
                          className="my-4"
                        />
                        <Typography.Text className="ml-4">
                          {item.rating}/5
                        </Typography.Text>
                      </div>

                      <div className="flex product-info-wrapper">
                        <div className="product-info-box">
                          <h1>{item.sales_count_str}</h1>
                          <div>Total Units Sold</div>
                        </div>
                        <div className="product-info-box">
                          <h1>{item.sales_amount_str}</h1>
                          <div>Total Revenue</div>
                        </div>
                      </div>
                      <div className="details-btn cursor-pointer">Details</div>
                    </div>
                    <img
                      src={item.cover}
                      alt=""
                      className="inline-block w-30 h-32 lg:w-30 lg:h-38 xl:w-44 xl:h-46 xxl:w-72 xxl:h-80"
                    />
                  </div>
                </ClientLink>
              </SwiperSlide>
            );
          }
        )}
      </Swiper>
    </div>
  );
};

export default HighCommissions;
